import Layout from './Layout';

const Contend = ({ onLogout, userRole }) => {
	return (
		<Layout title="หน้าเปล่า" onLogout={onLogout} userRole={userRole}>
			<div className="space-y-6">
				เพิ่มเนื้อหา
			</div>
		</Layout>
	);
};

export default Contend;
